import { useRef, useEffect } from "react";
import "./sponsors.css";

import c4f from "../img/c4f.png";
import cruise from "../img/cruise.png";
import cuneri from "../img/cuneri.png";
import ivanic from "../img/ivanic.png";
import zapresic from "../img/zapresic.png";



export default function Klubovi() {
  const trackRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;

    const update3D = () => {
      const cards = track.querySelectorAll(".sponsor");
      const center = window.innerWidth / 2;

      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;

        const dist = (cardCenter - center) / center;

        const rotateY = dist * 14;
        const scale = 1 - Math.abs(dist) * 0.2;

        card.style.transform = `
          perspective(1000px)
          rotateY(${rotateY}deg)
          scale(${scale})
        `;

        card.style.opacity = 1 - Math.abs(dist) * 0.3;
      });

      requestAnimationFrame(update3D);
    };

    update3D();
  }, []);

  const logos = [c4f, cruise, cuneri, ivanic, zapresic];

  return (
    <div className="sponsors-wrap">
      <h2 className="sponsors-title">KLUBOVI KOJI NAM DOLAZE</h2>

      <div className="marquee">
        <div className="track" ref={trackRef}>
          {[...logos, ...logos].map((logo, i) => (
            <div className="sponsor" key={i}>
              <img
                src={logo}
                alt="sponsor"
                />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}